export default {
  meta: {
    title: "Basetao Spreadsheet : Produits, Avis et Guide d'expédition",
    description: "Plateforme indépendante sur Basetao Spreadsheet — trouvez des produits, comparez les vendeurs, vérifiez les photos QC, les frais d'expédition et la fiabilité de Basetao.",
  },
  brand: "Basetao Sheet",
  nav: {
    home: "Accueil",
    categories: "Catégories",
    shoppingGuide: "Guide d'achat",
    readGuide: "Lire le guide",
    safety: "Sécurité",
  },
  button: {
    buyNow: "Acheter maintenant",
    basetaoSpreadsheet: "Basetao Spreadsheet",
    readGuide: "Lire le guide",
    readArticle: "Lire l'article complet",
    exploreCategories: "Explorer les catégories",
    backHome: "Retour à l'accueil",
    visitMain: "Visiter le site principal",
    viewAll: "Tout voir",
  },
  cat: {
    shoes: "Chaussures",
    hoodies: "Hoodies / Sweats",
    tshirts: "T-shirts",
    jackets: "Vestes",
    pants: "Pantalons / Shorts",
    headwear: "Couvre-chefs",
    sets: "Ensembles",
    underwear: "Sous-vêtements / Slips",
    jersey: "Maillots",
    accessories: "Accessoires",
    bags: "Sacs",
    belts: "Ceintures",
    perfumes: "Parfums",
    other: "Autres articles",
  },
  notFound: {
    title: "Page introuvable",
    desc: "La page que vous recherchez n'existe pas ou a été déplacée.",
  },
  footer: {
    tagline: "Ressource d'information indépendante sur Basetao Spreadsheet.",
    quickLinks: "Liens rapides",
    categories: "Catégories",
    disclaimer: "Basetao Sheet est une ressource d'information indépendante et n'est pas officiellement affiliée à Basetao. Les informations peuvent changer et doivent être vérifiées avant tout achat ou paiement.",
    allRights: "Tous droits réservés.",
  },
  articleMeta: {
    shortAnswerLabel: "En bref",
    tocTitle: "Sommaire",
    checklistTitle: "Points clés à vérifier",
    faqTitle: "Questions fréquentes",
    conclusionTitle: "En résumé",
    authorLabel: "Auteur",
    author: "Équipe éditoriale Basetao Sheet",
    publishedLabel: "Publié",
    published: "2026",
    updatedLabel: "Mis à jour",
    updated: "Août 2026",
    disclaimer:
      "Basetao Sheet est une ressource d'information indépendante et n'est pas officiellement affiliée à Basetao. Les informations peuvent changer et doivent être vérifiées avant tout achat ou paiement.",
  },
};